export enum GroupMemberType {
    User = 'User',
    Group = 'Group',
    ServicePrincipal = 'Service Principal'
}